




import Vue from 'vue'

import type { HTMLInputEvent } from '@/models/common'

// Hack-fix for mobile autocomplete
// https://github.com/vuejs/vue/issues/8231
export default Vue.extend({
  props: {
    value: {
      default: () => '',
    },
  },
  methods: {
    handleInput(e: HTMLInputEvent) {
      this.$emit('input', e.target.value)
    },
  },
})
